import { FilterIcon } from '../../../icons/SvgIcons';

export function AppliedFilters({
  text = 'Applied Filters:',
}: {
  text?: string;
}) {
  return (
    <div className="flex items-center space-x-2 text-gray-800 font-medium leading-5 flex-shrink-0">
      {FilterIcon()}
      <span className="text-sm leading-5">{text}</span>
    </div>
  );
}
